export enum ACCOUNT_DELETION_REASON_PERMISSIONS {
  ACCOUNT_DELETION_REASON_VIEW = 'ACCOUNT_DELETION_REASONS_VIEW',
  ACCOUNT_DELETION_REASON_WRITE = 'ACCOUNT_DELETION_REASONS_WRITE',
}
